<template>
  <div class="needs_progress flex">
    <div class="progress_all">
      <div class="progress_dog">
        <div class="dog" :style="dog_progress"></div>
      </div>
      <div class="progress">
        <div :class="['progress-bar', barColor]"  :style="dog_progress_1" >

        </div>
      </div>
    </div>
    <div class="progress_num">
      <b style="color: black;">{{ this.page.page_no }} / {{ this.page.total }}</b>
    </div>

  </div>
</template>

<script>
export default {
  name: "progress_bar",
  props: {
    page: Object
  },
  data: function () {
    return {
      moduleName: '',
      totalLevel: 7,
      star: 0,
      circle: 0,
      barColor: '',
    }
  },
  methods: {
    getStarAmount(page) {
      this.star = page;
      this.circle = this.totalLevel - page;
    },
    setBarColor() {
      switch (this.moduleName) {
        case "buyHouse":
          this.barColor = 'house_progress-bar';
          break
        case "educationFund":
          this.barColor = 'edu_progress-bar'
          break
        default:
          this.barColor = "retire_progress-bar"
          break
      }
    }
  },
  created() {
    this.moduleName = store.get('moduleName')
    this.totalLevel = this.page.isRetire ? 6 : store.get(`${this.moduleName}/data`).length
    this.getStarAmount(this.page);
    this.setBarColor()
  },
  mounted() {
  },
  computed: {
    dog_progress() {
      return `left:calc(${this.page.page_no} / ${this.page.total} * 100%);`
    },
    dog_progress_1() {
      return `width:calc(${this.page.page_no} / ${this.page.total} * 100%);`
    }
  }
}

</script>

<style scoped>
.edu_progress-bar {
  background-color: #F49202 !important;
}

.house_progress-bar {
  background-color: #EF8370 !important;
}

.retire_progress-bar {
  background-color: #62c4d3 !important;
}
</style>